<template>
    <div>
        <!-- 头部 -->
        <v-header></v-header>
        
        <div class="media-wrap">
            <!-- banner -->
            <div class="banner-box">
                <img src="http://wx4.sinaimg.cn/large/0067mezugy1fj37u4nowlj31hc0godhx.jpg" width="100%" class="banner" ref="top"/>
                <div class="search">
                    <input type="text" placeholder="搜索资讯" v-model="searchname" @keyup.13="search()">
                    <i class="icon-search" @click="search()"></i>
                </div>
            </div>
            <!-- 唐麦资讯 -->
            <div class="box">
                <div class="media-box"><h2 class="wrapCenter">新闻资讯</h2></div>

                <!-- <div class="media-box" v-for="item in mediaList">
                    <div class="wrapCenter media-title" @click="getMediaDetail(item.id)">
                        <h3>{{ item.subtitle.split(" ")[0] }} <i class="media-title-icon" :class="{open: showId == item.id}"></i></h3>
                        <span class="title-time">{{item.createTime | date}}</span>
                    </div>
                    <div class="wrapCenter media-detail" :id="'media' + item.id">
                        <img class="media-image" :src="mediaDetail.image" width="100%">
                        <h3 class="media-detail-title"> {{mediaDetail.title}} </h3>
                        <h4 class="media-detail-subtitle"> {{mediaDetail.subtitle}} </h4>
                        <div class="media-content" v-html="mediaDetail.content"></div>
                        <p class="media-info">
                            <span> {{mediaDetail.create_time | date}} </span>
                            <span> <i class="icon-visitor"></i>{{mediaDetail.visit}} </span>
                            <span> <i class="icon-weibo" @click="shareTSina(mediaDetail.title, 'http://www.tangmai.com.cn/media', mediaDetail.image)"></i> </span>
                            <span class="media-close" @click="getMediaDetail(item.id)"> <i></i> </span>
                        </p>
                    </div>
                </div> -->
                <div class="media-box2" v-for="(item, index) in mediaList" :key="index">
                    <div class="wrapCenter media-title">
                        <!-- <h3>{{ item.title }}</h3>
                        <span class="title-time">{{item.createTime | date}}</span> -->
                        <a :href="item.links[0].url" target="_blank"><img :src="item.image" /></a>
                        <div class="media_label">
                            <h3>{{item.title}}</h3>
                            <p>
                                <span v-for="(link, lindex) in item.links" :key="lindex"><a :href="link.url" target="_blank">{{link.name}}</a><span v-if="lindex !== item.links.length-1"> / </span> </span> 等报导
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 更多 -->
            <!--<button class="btn btn-default btn-more">更多</button>-->
        </div>
        <!-- 尾部 -->
        <v-footer></v-footer>
        <!-- 回到顶部 -->
        <goto-top></goto-top>
    </div>
</template>
<script>
    import VHeader from "../components/header"
    import VFooter from "../components/footer"
    // 回到顶部
    import GotoTop from "../components/gotoTop"
    import {getMediaList, getMediaDetail} from "../server/getData"

    export default {
        components: {
            VHeader,
            VFooter,
            GotoTop
        },
        data() {
            return {
                showId: "",
                mediaList: [{
                    title: "企业介绍",
                    image: "https://wx3.sinaimg.cn/large/0067mezugy1gtk3m5swhej31hc0kudlf.jpg",
                    links: [{
                        name: "新浪微博",
                        url: "https://weibo.com/ttarticle/p/show?id=2309404670877316022681"
                    }]
                // },{
                //     title: "匠心工艺+多维创新，唐麦W3真无线蓝牙耳机惊艳亮相",
                //     image: "https://wx1.sinaimg.cn/large/0067mezugy1ga22d5a8yjj31hc0ku0zh.jpg",
                //     links: [{
                //         name: "凤凰网",
                //         url: "https://tech.ifeng.com/c/7sMsD1Onr1n"
                //     },{
                //         name: "中国IT研究中心",
                //         url: "http://www.cnit-research.com/content/201912/38404.html" 
                //     },{
                //         name: "IT168",
                //         url: "http://software.it168.com/a2019/1213/6105/000006105463.shtml"
                //     }]
                // },{
                //     title: "唐麦W1耳机：孤独指数100%，你与世界只差3秒的距离",
                //     image: "https://wx4.sinaimg.cn/large/0067mezugy1g8g6n0k5pzj31hc0kudjl.jpg",
                //     links: [{
                //         name: "搜狐网",
                //         url: "https://www.sohu.com/a/348987824_100043501"
                //     },{
                //         name: "腾讯网",
                //         url: "https://fj.qq.com/a/20191023/007357.htm"
                //     },{
                //         name: "人工智能信息网",
                //         url: "http://www.cnaifm.com/jpdg/2019-10-23/4738.html"
                //     }]
                },{
                    title: "唐麦推出全新“X”系列真无线游戏蓝牙耳机唐麦X3",
                    image: "https://wx4.sinaimg.cn/large/0067mezugy1gsfe7nerwdj31hc0kutgu.jpg",
                    links: [{
                        name: "腾讯网",
                        url: "https://new.qq.com/omn/20210712/20210712A05J4500.html"
                    },{
                        name: "砍柴网",
                        url: "https://baijiahao.baidu.com/s?id=1705058914269408087&wfr=spider&for=pc"
                    },{
                        name: "南方财富网",
                        url: "http://www.southmoney.com/caijing/gongsixinwen/202107/12759894.html"
                    },{
                        name: "飞象网",
                        url: "http://www.cctime.com/html/2021-7-12/1581038.htm"
                    },{
                        name: "站长之家",
                        url: "https://www.chinaz.com/2021/0712/1276892.shtml"
                    }]
                },{
                    title: "颜值舒适真的第一？唐麦W9蓝牙耳机开箱评测体验",
                    image: "https://wx1.sinaimg.cn/large/0067mezugy1gsfe7kt7koj31hc0kuad8.jpg",
                    links: [{
                        name: "百家号",
                        url: "https://baijiahao.baidu.com/s?id=1697066744219614215&wfr=spider&for=pc"
                    }]
                // },{
                //     title: "唐麦W5动铁蓝牙耳机体验，享受聆听，瞬间入戏！",
                //     image: "https://wx2.sinaimg.cn/large/0067mezugy1gsfe7i2g9cj31hc0ku78u.jpg",
                //     links: [{
                //         name: "百家号",
                //         url: "https://baijiahao.baidu.com/s?id=1674648343129936653&wfr=spider&for=pc"
                //     }]
                },{
                    title: "唐麦耳机，专注深耕影音行业5年，致力于将耳机做得极致",
                    image: "https://wx2.sinaimg.cn/large/0067mezugy1g7ult6mxhbj31hc0kudiq.jpg",
                    links: [{
                        name: "搜狐网",
                        url: "https://www.sohu.com/a/333604250_100043501"
                    },{
                        name: "网易新闻",
                        url: "http://3g.163.com/dy/article/EMHLMR2T0514EEEP.html"
                    },{
                        name: "国际日报",
                        url: "http://www.chinesetoday.com/qiye/keji/20190814/1565765314.html"
                    }]
                // },{
                //     title: "唐麦耳机助力高校开学季，让你听见更美好的大学生活",
                //     image: "https://wx3.sinaimg.cn/large/0067mezugy1g7ulskg0w2j31hc0ku3zz.jpg",
                //     links: [{
                //         name: "中国经济新闻网",
                //         url: "http://www.cet.com.cn/xwsd/2336649.shtml"
                //     },{
                //         name: "站长之家",
                //         url: "https://www.chinaz.com/news/mt/2019/0828/1043082.shtml"
                //     },{
                //         name: "网易新闻手机端",
                //         url: "http://3g.163.com/dy/article/ENM3J1R10514EEEP.html"
                //     }]
                },{
                    title: "坚守初心本真，唐麦科技，致力于打造一流的影音体验",
                    image: "https://wx2.sinaimg.cn/large/0067mezugy1g7ult4fwmpj31hc0ku0wc.jpg",
                    links: [{
                        name: "搜狐网",
                        url: "https://www.sohu.com/a/332066038_100043501"
                    },{
                        name: "腾讯网",
                        url: "https://new.qq.com/omn/20190807A0AHWH00"
                    },{
                        name: "凤凰网",
                        url: "https://biz.ifeng.com/c/7owgPrFTNSq"
                    },{
                        name: "新浪网",
                        url: "http://vr.sina.com.cn/news/hz/2019-08-07/doc-ihytcerm9150920.shtml"
                    }]
                // },{
                //     title: "世间纷扰，只听自己----唐麦A8四核耳机",
                //     image: "https://wx2.sinaimg.cn/large/0067mezugy1g7ult27c8gj31hc0kugsg.jpg",
                //     links: [{
                //         name: "消费日报",
                //         url: "http://www.xfrb.com.cn/article/stjj-qyzx/15165062686444.html"
                //     },{
                //         name: "中华网",
                //         url: "https://hea.china.com/article/20190821/home0129350332.html"
                //     },{
                //         name: "站长之家",
                //         url: "http://www.chinaz.com/news/mt/2019/0822/1041588.shtml"
                //     }] 
                // },{
                //     title: "唐麦W1真无线蓝牙耳机惊喜上市，匠心让耳朵更加亲密",
                //     image: "https://wx2.sinaimg.cn/large/0067mezugy1g7ulszsjpqj31hc0kudie.jpg",
                //     links: [{
                //         name: "中国广播网",
                //         url: "http://www.cnr.cn/rdzx/cxxhl/zxxx/20190929/t20190929_524799609.shtml"
                //     },{
                //         name: "中华网",
                //         url: "https://hea.china.com/article/20190929/home0129377872.html"
                //     },{
                //         name: "艾瑞网",
                //         url: "http://news.iresearch.cn/yx/2019/09/303590.shtml"
                //     }]
                // },{
                //     title: "实用好耳机---唐麦N1颈挂式蓝牙耳机开箱",
                //     image: "https://wx4.sinaimg.cn/large/0067mezugy1g7ulsnk2qhj31hc0kuwg2.jpg",
                //     links: [{
                //         name: "中国日报网",
                //         url: "http://chuangxin.chinadaily.com.cn/a/201909/19/WS5d831ab6a31099ab995e0eea.html"
                //     },{
                //         name: "中国经济新闻网",
                //         url: "http://www.cet.com.cn/itpd/sm/2360125.shtml"
                //     },{
                //         name: "南方网科技",
                //         url: "http://tech.southcn.com/t/2019-09/19/content_189036949.htm"
                //     }]
                // },{
                //     title: "唐麦N1超高性价比颈挂式蓝牙耳机试用，这款是真的爱了~",
                //     image: "https://wx3.sinaimg.cn/large/0067mezugy1g7ulspujlqj31hc0kumza.jpg",
                //     links: [{
                //         name: "搜狐媒体",
                //         url: "https://www.sohu.com/a/343458845_100043501"
                //     },{
                //         name: "中华网",
                //         url: "https://hea.china.com/article/20190926/home0129374707.html"
                //     },{
                //         name: "国际在线",
                //         url: "http://ge.cri.cn/20190926/8a6f6625-b2d8-cab2-36c1-d1aae7cf473b.html"
                //     }]
                // },{
                //     title: "始于颜值，忠于实力：唐麦耳机A8升级版测评",
                //     image: "https://wx1.sinaimg.cn/large/0067mezugy1g7ulsef2gqj31hc0kutby.jpg",
                //     links: [{
                //         name: "搜狐网",
                //         url: "http://www.sohu.com/a/340310256_100043501"
                //     },{
                //         name: "腾讯网",
                //         url: "https://new.qq.com/omn/20190911A0G8OG00"
                //     },{
                //         name: "中华网",
                //         url: "https://hea.china.com/article/20190911/home0129365087.html"
                //     },{
                //         name: "IT1688",
                //         url: "http://software.it168.com/a2019/0911/6053/000006053819.shtml"
                //     }]
                // },{
                //     title: "够新鲜！全新唐麦A8升级款开箱晒照",
                //     image: "https://wx1.sinaimg.cn/large/0067mezugy1g7ulshus2tj31hc0kuadu.jpg",
                //     links: [{
                //         name: "中华网",
                //         url: "https://hea.china.com/article/20190905/home0129360399.html"
                //     },{
                //         name: "极客网",
                //         url: "http://www.fromgeek.com/latest/262032.html"
                //     },{
                //         name: "百家号",
                //         url: "http://baijiahao.baidu.com/s?id=1643803327380679641&wfr=spider&for=pc"
                //     }]
                }],
                mediaListAll: [],
                mediaDetail: {},
                searchname: ""
            }
        },
        methods: {
            search() {
                // this.getMediaList(() => {
                    
                // });
                if (this.searchname) {
                    this.mediaList = [];
                    var name = this.searchname.toLowerCase();

                    for (var i = 0; i < this.mediaListAll.length;i++) {
                        var title = this.mediaListAll[i].title.toLowerCase();
                        // var subtitle = this.mediaList[i].subtitle.toLowerCase();
                        if (title.indexOf(name) != -1) {
                            this.mediaList.push(this.mediaListAll[i])
                        }
                    }
                }else{
                    this.mediaList = this.mediaListAll
                }
            },
            async getMediaList(cb) {
                let res = await getMediaList();
                if (res.data.resCode == 0) {
                    this.mediaList = res.data.result;
                    if (cb) {
                        cb();
                    }
                }
            },
            async getMediaDetail(id) {
                var self = this;
                if (this.showId == id) {
                    $("#media" + id).slideUp(500);
                    self.showId = "";

                } else {
                    //ajax获取新闻详情
                    let res = await getMediaDetail(id);
                    if (res.data.resCode == 0) {
                        this.mediaDetail = res.data.result;
                        this.showId = id;
                        $(".media-detail").slideUp(500);
                        $("#media" + id).slideDown(500);
                    }
                }

            },
            shareTSina(title, rLink, pic) {
                var top = window.screen.height / 2 - 250;
                var left = window.screen.width / 2 - 300;
                /*title是标题，rLink链接，summary内容，site分享来源，pic分享图片路径,分享到新浪微博*/
                window.open("http://service.weibo.com/share/share.php?pic=" + encodeURIComponent(pic) + "&title=" +
                    encodeURIComponent(title.replace(/&nbsp;/g, " ").replace(/<br \/>/g, " ")) + "&url=" + encodeURIComponent(rLink),
                    "分享至新浪微博",
                    "height=500,width=600,top=" + top + ",left=" + left + ",toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no");
            }
        },
        beforeMount() {
            // this.getMediaList();
            this.mediaListAll = JSON.parse(JSON.stringify(this.mediaList));
        }
    }
</script>
<style scoped>
    .media-wrap {
        margin-top: 80px;
        padding-bottom: 60px;
    }
    
    .box {
        padding-top: 70px;
    }
    
    .media-box {
        border-bottom: 1px #e7e7e7 solid;
    }
    
    .media-box h2 {
        font-size: 24px;
        color: #7c7c7c;
        margin-bottom: 20px;
    }
    
    .media-title {
        overflow: hidden;
        padding: 10px 0;
    }
    
    .media-title h3 {
        font-size: 16px;
        font-weight: 400;
        color: #7c7c7c;
        float: left;
    }
    
    .media-title .media-title-icon {
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        /*margin-top: -3px;*/
        margin-left: 10px;
        cursor: pointer;
        background: url(../assets/img/icons/add.png) no-repeat center;
        background-size: contain;
    }
    
    .media-title .media-title-icon.open {
        background: url(../assets/img/icons/close.png) no-repeat center;
        background-size: contain;
    }
    
    .title-time {
        float: right;
        color: #7c7c7c;
    }
    
    .media-detail {
        display: none;
    }
    
    .media-image {
        margin-top: 10px;
    }
    
    .media-detail-title {
        margin-top: 30px;
        font-size: 30px;
        color: #747474;
    }
    
    .media-detail-subtitle {
        margin-top: 10px;
        font-size: 20px;
        color: #747474;
    }
    
    .media-content {
        margin: 30px 0;
    }
    
    .media-info {
        color: #a6a6a6;
        margin-bottom: 10px;
    }
    
    .media-info span {
        font-weight: 400;
        margin-right: 20px;
    }
    
    .icon-visitor,
    .icon-weibo {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        margin-right: 6px;
        margin-top: -2px;
    }
    
    .icon-visitor {
        background: url(../assets/img/icons/eye2.png) no-repeat center;
        background-size: contain;
    }
    
    .icon-weibo {
        background: url(../assets/img/icons/weibo2.png) no-repeat center;
        background-size: contain;
        cursor: pointer;
    }
    
    .media-close {
        float: right;
        background: #ebebeb;
        padding: 8px;
        cursor: pointer;
        margin-top: -10px;
    }
    
    .media-close i {
        width: 16px;
        height: 16px;
        background: url(../assets/img/icons/close.png) no-repeat center;
        background-size: contain;
        display: block;
    }
    
     ::-webkit-input-placeholder {
        color: #ffffff;
    }
    
     :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ffffff
    }
    
     ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ffffff
    }
    
     :-ms-input-placeholder {
        color: #ffffff
    }

    .media-box2{
        margin: 10px 0
    }

    .media-box2 img{
        width: 100%;
    }

    .media-box2 .media_label{
        /* position: absolute; */
        left: 0;
        bottom: 0;
        background: #f0eff5;
        height: 60px;
        width: 100%;
        padding: 0 16px;
    }
    .media-box2 .media_label h3{
        float: left;
        line-height: 60px;
        /* font-weight: bold; */
        font-size: 16px;
        color: #000000;
    }
    .media-box2 .media_label p{
        text-align: right;
        float: right;
        line-height: 60px;
        color: #666666;
    }

    .media-box2 .media_label p a{
        color: #666666;
    }
    
    @media (max-width: 768px) {
        .box {
            padding-top: 1rem;
        }
        .media-wrap {
            margin-top: 60px;
        }
        .media-box {
            padding: 0.3rem 0.6rem;
        }
        .media-box h2 {
            font-size: 0.8rem;
        }
        .media-title h3 {
            font-size: 0.6rem;
        }
        .media-title .media-title-icon {
            width: 0.6rem;
            height: 0.6rem;
        }
        .title-time {
            font-size: 0.6rem;
        }
        .media-detail-title {
            font-size: 0.8rem;
        }
        .media-detail-subtitle {
            font-size: 0.7rem;
        }
        .media-content {
            margin: 0.6rem 0;
        }
        .media-info span {
            font-size: 0.5rem;
        }
        .icon-visitor,
        .icon-weibo {
            width: 0.6rem;
            height: 0.6rem;
        }
        .media-close {
            padding: 0.2rem;
            margin-top: 0px;
        }
        .media-close i {
            width: 0.5rem;
            height: 0.5rem;
        }

        .media-box2 .media_label{
            height: 70px;
            padding: 0 16px;
        }
        .media-box2 .media_label h3{
            font-size: 16px;
            line-height: 40px;
            width: 100%;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
        .media-box2 .media_label p{
            line-height: 30px;
            text-align: left;
            float: left;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/media.vue